import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// Packages
import { Helmet } from 'react-helmet';

// API
import * as API  from '../../../utils/api';

// Components
import Header from '../../../components/Global/Header';
import LinkToCategory from '../../../components/ResourceLibrary/LinkToCategory';
import AppCanvasLoader from '../../../components/Global/AppCanvasLoader';
import LockedLink from '../../../components/Global/LockedLink';

class ResourceLibraryArchive extends Component {

  state = {
    posts: [],
    categories: [],
    categoriesLoading: true,
    postsLoading: true
  }

  componentDidMount() {
    const { user } = this.props
    const currentCategory = this.props.match.params.category;

    this.setCategories(user)
    this.setPosts(user, currentCategory)
  }

  componentWillReceiveProps(nextProps) {
    const { user } = this.props
    const currentCategory = this.props.match.params.category;
    const nextCategory = nextProps.match.params.category;

    if (!this.hasCategories()) {
      this.setCategories(user)
    }

    if (!this.hasPosts() || nextCategory !== currentCategory) {
      this.setState({
        postsLoading: true
      }, this.setPosts(user, nextCategory))
    }
  }

  hasCategories = () => this.state.categories.length > 0

  hasPosts = () => this.state.posts.length > 0

  setPosts(user, category) {
    API.getResourceLibraryCategory(user, category)
    .then(posts => this.setState({
      posts,
      postsLoading: false
    }));
  }

  setCategories(user) {
    API.getResourceLibraryCategories(user)
    .then(categories => this.setState({
      categories,
      categoriesLoading: false
    }));
  }

  activeCategory = () => {
    const activeCategoryID = this.props.match.params.category
    const { categories } = this.state

    return categories.find(c => parseInt(c.wp_id, 10) === parseInt(activeCategoryID, 10))
  }

  render() {
    const { path, appName, activeProfile } = this.props;
    const {
      posts,
      categories,
      categoriesLoading,
      postsLoading
    } = this.state;
    const { category } = this.props.match.params;
    const activeCategory = this.activeCategory();
    const trialInfo = activeProfile.trial_info;

    return (
      <div className="user-portal resource-library">
        <Helmet>
          <title>{appName} | Resource Library Archive</title>
        </Helmet>
        <Header path={ path }/>
        {
          categoriesLoading
          ? (
            <div className="resource-library-loader-wrap">
              <AppCanvasLoader />
            </div>
          )
          : (
            <section>
              <div className="inner-wrap resource-library-archive resource-library-container">
                <div className="resource-library-archive-overview resource-library-aside">
                  <h4>Resource Library</h4>
                  <h1>{activeCategory && activeCategory.name}</h1>
                  <p>{activeCategory && activeCategory.description}</p>
                  <div className="resource-library-archive-overview-categories">
                    <h4>Categories</h4>
                    {
                      categories.map((category, index) => <LinkToCategory key={index} category={category} />)
                    }
                  </div>
                </div>
                <div className="resource-library-archive-list resource-library-content">
                  {
                    postsLoading
                    ? (<AppCanvasLoader />)
                    : (
                      posts.map((post) => {
                        function createMarkup() {
                          return {__html: post.excerpt};
                        }

                        return (
                          <div key={post.wp_id} className="resource-library-archive-list-post">
                            <h5>Article</h5>
                            <h2>{post.title}</h2>
                            <div dangerouslySetInnerHTML={createMarkup()} />
                            { trialInfo.on_trial && trialInfo.trial_expired
                              ? (
                                <LockedLink />
                              ) : (
                                <Link className="read-more" to={`${category}/${post.wp_id}`}>Read More</Link>
                              )
                            }
                          </div>
                        )
                      })
                    )
                  }
                </div>
              </div>
            </section>
          )
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    activeProfile: state.activeProfile,
    user: state.user
  }
}

export default connect(
  mapStateToProps,
  null
)(ResourceLibraryArchive)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/ResourceLibrary/ResourceLibraryArchive.js